<template>
  <div class="login_container">
    <div class="login_box">
      <h1 style="margin-top: 50px">后台管理系统</h1>

      <!--  登录表单 -->
      <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" label-width="0px" class="login_info">
        <el-form-item prop="phoneNum">
          <el-input v-model="loginForm.adminUserPhone" prefix-icon="el-icon-user"  @keyup.enter.native="handleEnterKey"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.adminUserPwd" type="password" prefix-icon="el-icon-lock"  @keyup.enter.native="handleEnterKey"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="login">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {Message} from "element-ui"

export default {
  name: "Login",
  data() {
    return {
      // 登录表单的数据
      loginForm: {
        adminUserPhone: '',
        adminUserPwd: ''
      },
      // 表单验证规则
      loginFormRules: {
        adminUserPhone: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {min: 3, max: 20, message: '长度在 3 到 12 个字符', trigger: 'blur'}
        ],
        adminUserPwd: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur'}
        ]
      }
    }
  },

  methods: {
    // 登录
    async login() {
      const {data: res} = await this.$http.post("/alogin", this.loginForm)
      console.log(this.loginForm)

      if (res.data != null) {
        Message.success('登陆成功')
        sessionStorage.setItem('token', res.data)
        sessionStorage.setItem('adminUser', res.data.adminUser)
        sessionStorage.setItem('isAdmin',JSON.stringify(res.data.isAdmin))
        sessionStorage.setItem('ID',JSON.stringify(res.data.id))
        this.$router.push('/mg')
        location.reload()
      } else {
        console.log(res.data)
        Message.error('登陆失败')
      }
    },
    //处理Enter键的逻辑
    handleEnterKey() {
      // 处理Enter键的逻辑
      console.log('处理Enter键的逻辑11')
      //调用方法
      this.login();
    },
  }
}
</script>

<style lang="less" scoped>
.login_container {
  background-image: url("../../../assets/image/bc2.jpg");
  background-size: cover;
  height: 100%;
}

.login_box {
  width: 300px;
  height: 350px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 15px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.login_info {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}

</style>

